import { AdminEndpoint } from "./api/admin/admin-endpoint";
import { SystemEndpoint } from "./api/system/system-endpoint";
import { V2Endpoint } from "./api/v2/v2-endpoint";
/**
 * Contains endpoints to interact with DSP-API.
 *
 * @category Config
 */
var KnoraApiConnection = /** @class */ (function () {
    /**
     * Sets up all endpoints.
     *
     * @param knoraApiConfig the configuration for the DSP-API instance to connect to.
     */
    function KnoraApiConnection(knoraApiConfig) {
        // Instantiate the endpoints
        this.system = new SystemEndpoint(knoraApiConfig, KnoraApiConnection.PATH_SYSTEM);
        this.admin = new AdminEndpoint(knoraApiConfig, KnoraApiConnection.PATH_ADMIN);
        this.v2 = new V2Endpoint(knoraApiConfig, KnoraApiConnection.PATH_V2);
        // todo more
    }
    KnoraApiConnection.PATH_SYSTEM = "";
    KnoraApiConnection.PATH_ADMIN = "/admin";
    KnoraApiConnection.PATH_V2 = "/v2";
    return KnoraApiConnection;
}());
export { KnoraApiConnection };
